import { render } from "./MultiSensorProfileArea.vue?vue&type=template&id=0f1423cd&scoped=true"
import script from "./MultiSensorProfileArea.vue?vue&type=script&lang=js"
export * from "./MultiSensorProfileArea.vue?vue&type=script&lang=js"

import "./MultiSensorProfileArea.vue?vue&type=style&index=0&id=0f1423cd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1423cd"]])

export default __exports__